import { LoginService } from 'application/services/login'
import { apiLogin } from 'infra/adapters/http-client-adapter'

export const handleLogin = new LoginService(apiLogin)
